import { WindowTitle } from "@dashboard/components/WindowTitle";
import { CountryCode, useUpdatePrivateMetadataMutation,useWarehouseCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import useShop from "@dashboard/hooks/useShop";
import { commonMessages } from "@dashboard/intl";
import { extractMutationErrors, findValueInEnum, getMutationStatus } from "@dashboard/misc";
import WarehouseCreatePage, {
  WarehouseCreatePageFormData,
} from "@dashboard/warehouses/components/WarehouseCreatePage";
import { warehouseUrl } from "@dashboard/warehouses/urls";
import React from "react";
import { useIntl } from "react-intl";

const WarehouseCreate = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const [updatePrivateMetadata] = useUpdatePrivateMetadataMutation({
    refetchQueries: ["WarehouseDetails"], // Refetch warehouse details after metadata update
  });
  const [createWarehouse, createWarehouseOpts] = useWarehouseCreateMutation();
  const createWarehouseTransitionState = getMutationStatus(createWarehouseOpts);
  const handleSubmit = async (data: WarehouseCreatePageFormData) => {
    const mutationPromise = createWarehouse({
      variables: {
        input: {
          address: {
            companyName: data.companyName,
            city: data.city,
            cityArea: data.cityArea,
            country: findValueInEnum(data.country, CountryCode),
            countryArea: data.countryArea,
            phone: data.phone,
            postalCode: data.postalCode,
            streetAddress1: data.streetAddress1,
            streetAddress2: data.streetAddress2,
          },
          name: data.name,
          email: data.email,
        },
      },
    });

    const result = await extractMutationErrors(mutationPromise);
    const mutationResult = await mutationPromise;
    
    if (result.length === 0 && mutationResult.data?.createWarehouse?.warehouse?.id) {
      const warehouseId = mutationResult.data.createWarehouse.warehouse.id;
      const metadataInput = [];
      
      if (data.longitude) {
        metadataInput.push({ key: "lng", value: data.longitude });
      }

      if (data.latitude) {
        metadataInput.push({ key: "lat", value: data.latitude });
      }

      if (data.siteLink) {
        metadataInput.push({ key: "url", value: data.siteLink });
      }
      
      if (metadataInput.length > 0) {
        await updatePrivateMetadata({
          variables: {
            id: warehouseId,
            input: metadataInput,
            keysToDelete: [],
          },
        });
      }
      
      navigate(warehouseUrl(warehouseId));
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges),
      });
    }
    
    return result;
  };

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          id: "GhcypC",
          defaultMessage: "Create Warehouse",
          description: "header",
        })}
      />
      <WarehouseCreatePage
        countries={shop?.countries || []}
        disabled={createWarehouseOpts.loading}
        errors={createWarehouseOpts.data?.createWarehouse?.errors || []}
        saveButtonBarState={createWarehouseTransitionState}
        onSubmit={handleSubmit}
      />
    </>
  );
};

WarehouseCreate.displayName = "WarehouseCreate";
export default WarehouseCreate;
